/**
 * FILE: assets/notify-when-available.js
 *
 * "Email When Available" flow for the Pro Liner product page.
 *
 * The cascade picker (assets/cascade-picker.js) dispatches a `variant:changed`
 * event whenever a full variant is resolved. When that variant is out of stock
 * (variant.available === false) we hide the buy area and reveal the "Email When
 * Available" button; when it's buyable we restore the buy area. The button opens
 * a modal that captures the shopper's email + marketing opt-in and POSTs it to a
 * configurable endpoint (blank = preview/stub mode, nothing is sent).
 *
 * Config: window.NWAConfig[sectionId] = { sectionId, endpoint, productHandle, productTitle }
 * Variant data is read from window.CascadePickerData[sectionId].variants.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function slugify(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // Generation option value is "3rd Gen | 1996 – 2002" (or just a year range for FJ).
  // The label uses the part before the pipe.
  function genLabel(option2) {
    if (!option2) return '';
    return option2.split(' | ')[0].trim();
  }

  // Build "Tundra 3rd Gen" / "Tacoma 2nd Gen 4cyl". option3 is only included when
  // the generation actually has more than one sub-option (so lone "Standard" is dropped).
  function selectionLabel(variant, variants) {
    var model = variant.option1 || '';
    var gen = genLabel(variant.option2);
    var parts = [model, gen];
    if (variant.option3) {
      var subs = {};
      variants.forEach(function (v) {
        if (v.option1 === variant.option1 && v.option2 === variant.option2 && v.option3 != null) subs[v.option3] = 1;
      });
      if (Object.keys(subs).length > 1) parts.push(variant.option3);
    }
    return parts.filter(Boolean).join(' ');
  }

  ready(function () {
    var cfgAll = window.NWAConfig || {};

    document.querySelectorAll('.nwa').forEach(function (root) {
      var sectionId = root.getAttribute('data-section');
      var cfg = cfgAll[sectionId] || {};
      var picker = (window.CascadePickerData && window.CascadePickerData[sectionId]) || {};
      var variants = picker.variants || [];

      var trigger = root.querySelector('.nwa__trigger');
      var modal = root.querySelector('.nwa__modal');
      var buyWrap = root.parentElement ? root.parentElement.querySelector('.product-buy-button') : null;

      var productEl = root.querySelector('.nwa__product');
      var form = root.querySelector('.nwa__form');
      var emailInput = root.querySelector('.nwa__email');
      var optin = root.querySelector('.nwa__optin');
      var errorEl = root.querySelector('.nwa__error');
      var successEl = root.querySelector('.nwa__success');
      var submitBtn = root.querySelector('.nwa__submit');
      var marketingForm = root.querySelector('.nwa__marketing-form');

      if (!trigger || !form) return;

      // Current out-of-stock selection (null when the shown variant is buyable / none).
      var current = null;

      function showNotify(variant) {
        current = variant;
        var label = selectionLabel(variant, variants);
        if (productEl) productEl.textContent = label || (cfg.productTitle || '');
        trigger.hidden = false;
        if (buyWrap) buyWrap.classList.add('nwa-hidden');
      }
      function hideNotify() {
        current = null;
        trigger.hidden = true;
        if (buyWrap) buyWrap.classList.remove('nwa-hidden');
      }

      document.addEventListener('variant:changed', function (e) {
        var d = e.detail || {};
        if (String(d.sectionId) !== String(sectionId)) return;
        var v = d.variant;
        if (v && v.available === false) showNotify(v);
        else hideNotify();
      });

      // ---- Submit ----
      function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } }
      function clearError() { if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; } }
      function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

      // Subscribe the shopper to Shopify email marketing via the native
      // newsletter (customer) form — same-origin, no token needed.
      function subscribeMarketing(email) {
        if (!marketingForm) return;
        var field = marketingForm.querySelector('input[name="contact[email]"]');
        if (field) field.value = email;
        try {
          var body = new URLSearchParams(new FormData(marketingForm)).toString();
          fetch(marketingForm.action, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body
          }).catch(function () {});
        } catch (err) { /* non-fatal */ }
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();
        var email = (emailInput.value || '').trim();
        if (!validEmail(email)) { showError('Please enter a valid email address.'); emailInput.focus(); return; }
        if (!current) { showError('Please select your vehicle first.'); return; }

        var label = selectionLabel(current, variants);
        var consent = !!(optin && optin.checked);
        var payload = {
          email: email,
          marketing_optin: consent,
          product: cfg.productTitle || '',
          product_handle: cfg.productHandle || '',
          variant_id: current.id,
          variant_label: label,
          tag: 'notify:' + slugify((cfg.productHandle || 'product') + '-' + label)
        };

        submitBtn.disabled = true;
        var origSubmitText = submitBtn.textContent;
        submitBtn.textContent = 'Submitting…';

        // Marketing subscription only when they opted in.
        if (consent) subscribeMarketing(email);

        function done() {
          form.hidden = true;
          if (successEl) successEl.hidden = false;
        }
        function fail() {
          submitBtn.disabled = false;
          submitBtn.textContent = origSubmitText;
          showError('Something went wrong. Please try again.');
        }

        if (cfg.endpoint) {
          // Fire-and-forget POST to the tabular endpoint (Google Apps Script
          // web app). Apps Script sends no CORS headers, so we use a simple
          // request with an opaque response and confirm optimistically on send.
          fetch(cfg.endpoint, {
            method: 'POST',
            mode: 'no-cors',
            body: JSON.stringify(payload)
          }).then(function () {
            done();
          }).catch(fail);
        } else {
          // Preview / stub mode — nothing is sent.
          console.log('[NotifyWhenAvailable] stub submit (no endpoint configured):', payload);
          done();
        }
      });
    });
  });
})();
